<template>
    <a v-if="preferences.searchVersion !== 2" href="#" class="btn btn-link"
       :aria-disabled="preferences.saving ? 'true' : 'false'" @click.prevent="activate">
        {{ preferences.saving ? 'Ativando...' : 'Experimente a nova pesquisa' }}
    </a>
</template>

<script>
const options = require('sci/helpers/interface-options')
const toastr = require('toastr')

export default {
    props: { menu: { type: Boolean, default: false } },
    data () {
        return { preferences: options.state }
    },
    methods: {
        async activate () {
            if (this.preferences.saving) return

            try {
                if (await options.activate()) {
                    const draft = window.location.pathname === '/properties/search/draft'
                    const query = new URLSearchParams(window.location.search).get('q') || ''
                    window.location.assign(options.searchUrl(draft, query))
                }
            } catch (error) {
                toastr.error('Não foi possível ativar a nova pesquisa. Tente novamente.')
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// NewSearchButton.vue?50078335